import { NavigateWithThread, FocusDashboard, Profile, EvaluationAnalysisPage } from '@yeshuman/sdk'
import { useState } from 'react'
import { Routes, Route, useParams } from 'react-router-dom'
import { InterviewerCandidatesPage } from '../../../components/interviewer/interviewer-candidates-page'
import { InterviewerInterviewsPage } from '../../../components/interviewer/interviewer-interviews-page'
import { InterviewerSessionPage } from '../../../components/interviewer/interviewer-session-page'
import { RolesPage } from '../../../components/recruiter/roles-page'
import { RoleDetailPage } from '../../../components/recruiter/role-detail-page'
import { consumePendingFocusPath } from '../../../lib/focus-handoff'

interface InterviewerRoutesProps {
  onStartConversation?: (message: string) => void
}

/** Dashboard, unless another focus stashed a deep link (e.g. brief → interview queue) before switching here. */
function InterviewerIndexRoute({ onStartConversation }: InterviewerRoutesProps) {
  const [pendingPath] = useState(() => consumePendingFocusPath('interviewer'))
  if (pendingPath) {
    return <NavigateWithThread to={pendingPath} />
  }
  return <FocusDashboard focus="interviewer" onStartConversation={onStartConversation} />
}

function InterviewerEvaluationRoute() {
  const { evaluationId } = useParams<{ evaluationId: string }>()
  if (!evaluationId) {
    return <NavigateWithThread to="/interviewer/candidates" />
  }
  return <EvaluationAnalysisPage evaluationId={evaluationId} context={{ kind: 'recruiter-talent' }} />
}

export function InterviewerRoutes({ onStartConversation }: InterviewerRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={<InterviewerIndexRoute onStartConversation={onStartConversation} />}
      />
      <Route path="profile" element={<Profile />} />
      <Route path="candidates" element={<InterviewerCandidatesPage />} />
      <Route path="interviews" element={<InterviewerInterviewsPage />} />
      <Route path="session" element={<InterviewerSessionPage />} />
      <Route path="session/:sessionId" element={<InterviewerSessionPage />} />
      <Route path="evaluations/:evaluationId" element={<InterviewerEvaluationRoute />} />
      <Route path="roles" element={<RolesPage />} />
      <Route path="roles/:roleId" element={<RoleDetailPage />} />
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}
